import * as React from "react";
import ReactLazyLoad from "react-lazyload";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Experiment, isVariantEnabled } from "components/utility/experiment";

interface LazyLoadProps {
  context?: ExtendedContextStore;
  children: React.ReactElement;
}

// Renders its children only when it is visible to the user
export const LazyLoad: React.FC<LazyLoadProps> = ({ context, children }) => {
  if (!children || !context) {
    return null;
  }

  if (shouldNotLazyLoad(context)) {
    return children;
  }

  return (
    <ReactLazyLoad once={true} offset={200}>
      {children}
    </ReactLazyLoad>
  );
};

const shouldNotLazyLoad = (context: ExtendedContextStore) => {
  if (context.queryParams?.["dynamicRender"] === "1") {
    return false;
  }

  // We should not lazy load for bots for SEO purposes
  const isBot =
    context.userAgent?.includes("bot") ||
    context.userAgent?.includes("naver") ||
    context.userAgent?.includes("Catchpoint");

  // Temporarily lazy load 100% of the time for New York HTG to collect data
  const isNewYorkHtg =
    context.searchContext?.pageType === "Travel-Guide-Hotels" &&
    String(context.searchContext?.location?.id) === "178293";

  return isBot || !(isVariantEnabled(context, Experiment.Blossom_Dynamic_Render) || isNewYorkHtg);
};
